import { FC, FormEvent, useState } from 'react';
import { Button } from '@datapeace/1up-frontend-web-ui';
import { ArrowRightOutlined, SettingOutlined } from '@ant-design/icons';
import { useCheckinByMobileContainer } from '@datapeace/vms-web-containers';
import {
  Layout,
  Header,
  Content,
  Footer,
  NavButtons,
  Form,
  DynamicForm,
  ConsentCard,
} from '@datapeace/vms-web-components';
import {
  BRAND_NAME,
  ROUTES,
  getSettingsFromLocalStorage,
  isConsentDisabledOrg,
} from '@datapeace/vms-web-utils';
import styles from '../custom-form-screen/custom-form-screen.module.scss';
import {
  useProfileContext,
  useProcessDataContext,
} from '@datapeace/vms-web-models';
import { useConfig } from '@datapeace/vms-web-hooks';

export const CheckinByMobile: FC = () => {
  const {
    formSchema,
    formData,
    setFormData,
    isLoading,
    onSubmit,
    onSettingsButtonClick,
  } = useCheckinByMobileContainer();

  const { email } = useProfileContext();
  const config = useConfig();
  const { vmsMode } = getSettingsFromLocalStorage(email);
  const { setProcessData } = useProcessDataContext();

  const isConsentDisabledInOrg = isConsentDisabledOrg(
    config?.currentOrganization?.id
  );
  const hasConsentConfig =
    !isConsentDisabledInOrg &&
    !!config?.consentConfig?.consent &&
    Object.keys(config.consentConfig.consent).length > 0;
  const [consentGiven, setConsentGiven] = useState(!hasConsentConfig);

  const handleConsentChange = (given: boolean, timestamp?: string) => {
    setConsentGiven(given);
    setProcessData({ consentProvidedAt: timestamp ?? null });
  };

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!consentGiven) return;
    onSubmit();
  };

  return (
    <Layout>
      <Header />
      <Content>
        <div className={styles.Form}>
          <Form
            onSubmit={handleSubmit}
            noValidate
            autoComplete="off"
            style={{
              display: 'flex',
              alignItems: 'stretch',
              flexDirection: 'column',
              gap: '1.25rem',
              width: '100%',
            }}
          >
            <ConsentCard
              consentConfig={
                isConsentDisabledInOrg ? null : config?.consentConfig
              }
              consentGiven={consentGiven}
              setConsentGiven={handleConsentChange}
              style={{ width: '100%' }}
            />

            <DynamicForm
              values={formData}
              items={formSchema}
              onChange={setFormData}
            />

            {(vmsMode === 'quick_mode_face' ||
              vmsMode === 'quick_mode_mobile') && (
              <Button
                loading={isLoading}
                size="large"
                htmlType="submit"
                type="primary"
                disabled={!consentGiven}
                style={{ width: '100%' }}
              >
                Continue
                <ArrowRightOutlined />
              </Button>
            )}

            {vmsMode !== 'quick_mode_face' &&
              vmsMode !== 'quick_mode_mobile' && (
                <NavButtons
                  loading={isLoading}
                  backLink={config.isMobilePlan ? ROUTES.HOME : ROUTES.REGISTER}
                  isDisabled={!consentGiven}
                />
              )}
          </Form>
        </div>
      </Content>

      {!!onSettingsButtonClick && (
        <Footer>
          <div>
            <Button
              icon={<SettingOutlined />}
              shape="circle"
              onClick={onSettingsButtonClick}
            />
            <span>{`Powered by ${BRAND_NAME}`}</span>
          </div>
        </Footer>
      )}
    </Layout>
  );
};
